import script from "./WorkInstructionDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkInstructionDetailView.vue?vue&type=script&setup=true&lang=js"

import "./WorkInstructionDetailView.vue?vue&type=style&index=0&id=5d370020&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d370020"]])

export default __exports__